import { Lock, Mail, RefreshCwIcon, ShieldX } from "lucide-react";
import { useCallback } from "react";

import ButtonWithIcon from "../ui/ButtonWithIcon";

import { Card, CardContent } from "@/components/ui/card";

const NoPermissionPage = (): JSX.Element => {
  const handleTryAgain = useCallback((): void => {
    window.location.href = "/";
  }, []);

  return (
    <main className='min-h-screen bg-background flex items-center justify-center p-4 sm:p-6 md:p-8'>
      <Card className='w-full max-w-md sm:max-w-lg md:max-w-xl border shadow-[0px_4px_25px_0px_rgba(0,0,0,0.05)] bg-card'>
        <CardContent className='p-6 sm:p-8 md:p-12'>
          <div className='flex flex-col items-center text-center'>
            {/* Icon Container */}
            <div className='relative mb-6 sm:mb-8'>
              <div className='w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 rounded-full bg-primaryLight flex items-center justify-center'>
                <ShieldX className='w-10 h-10 sm:w-12 sm:h-12 md:w-14 md:h-14 text-primary' />
              </div>
              <div className='absolute -bottom-1 -right-1 w-8 h-8 sm:w-9 sm:h-9 md:w-10 md:h-10 rounded-full bg-destructive/10 flex items-center justify-center'>
                <Lock className='w-4 h-4 sm:w-5 sm:h-5 text-destructive' />
              </div>
            </div>

            {/* Main Heading */}
            <h1 className='text-[1.25rem] sm:text-[1.5rem] md:text-[1.875rem] font-semibold text-foreground mb-3 sm:mb-4 text-balance font-sans'>
              Access Denied
            </h1>

            {/* Problem Description */}
            <p className='text-[0.8125rem] sm:text-[0.875rem] md:text-[0.9375rem] text-muted-foreground mb-2 max-w-sm sm:max-w-md text-pretty font-sans'>
              You don&apos;t have permission to access the dashboard.
            </p>

            {/* Subtitle - Contact Admin */}
            <div className='bg-muted rounded-lg p-4 sm:p-5 mb-6 sm:mb-8 w-full mt-4'>
              <div className='flex items-start gap-3'>
                <div className='w-8 h-8 sm:w-9 sm:h-9 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5'>
                  <Mail className='w-4 h-4 sm:w-5 sm:h-5 text-primary' />
                </div>
                <div className='text-left'>
                  <p className='text-[0.75rem] sm:text-[0.8125rem] font-medium text-foreground mb-1 font-sans'>
                    Need access?
                  </p>
                  <p className='text-[0.6875rem] sm:text-[0.75rem] md:text-[0.8125rem] text-muted-foreground text-pretty font-sans leading-relaxed'>
                    Please ask your administrator or manager to grant you the
                    necessary permissions.
                  </p>
                </div>
              </div>
            </div>

            {/* Action Buttons */}
            <ButtonWithIcon
              icon={<RefreshCwIcon className='w-4 h-4 mr-2' />}
              onClick={handleTryAgain}
              variant={"light"}
              className='w-32'
            >
              Try Again
            </ButtonWithIcon>

            {/* Help Text */}
            <p className='text-[0.5625rem] sm:text-[0.6875rem] text-muted-foreground mt-6 sm:mt-8 font-sans'>
              If you believe this is an error, please reach out to support.
            </p>
          </div>
        </CardContent>
      </Card>
    </main>
  );
};

export default NoPermissionPage;
